"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartType = exports.Types = exports.SourceTypes = exports.CustomerTypes = void 0;
var CustomerTypes;
(function (CustomerTypes) {
    CustomerTypes["CONSUMER"] = "consumer";
    CustomerTypes["SMB"] = "smb";
    CustomerTypes["FIRSTNET"] = "opss-firstnet";
})(CustomerTypes = exports.CustomerTypes || (exports.CustomerTypes = {}));
var SourceTypes;
(function (SourceTypes) {
    SourceTypes["JSON"] = "json";
    SourceTypes["SLOT"] = "slot";
    SourceTypes["TEMPLATE"] = "template";
    SourceTypes["JSONPRIME"] = "jsonPrime";
})(SourceTypes = exports.SourceTypes || (exports.SourceTypes = {}));
var Types;
(function (Types) {
    Types["FOOTER"] = "footer";
    Types["HEADER"] = "header";
    Types["NavigationStrip"] = "navigationstrip";
})(Types = exports.Types || (exports.Types = {}));
var CartType;
(function (CartType) {
    CartType["LEGACYCART"] = "LegacyCart";
    CartType["IDPCART"] = "IDPCart";
})(CartType = exports.CartType || (exports.CartType = {}));
//# sourceMappingURL=GlobalNavProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/global/GlobalNav/GlobalNavProps.js
// module id = 2395
// module chunks = 8